// Havun mobile-login beslislogica — HavunCore kb/patterns/havun-mobile-login.md.
//
// Los bestand zodat het loginscherm en het biometrie-voorstel na een
// magic-link-login dezelfde detectie gebruiken; twee kopieën lopen uiteen.

// Regel 1: geen schermbreedte-drempels. Die zien iPads, foldables en
// desktopmodus als desktop en toonden dan een QR op een handheld.
export function isMobileDevice() {
  const coarse = window.matchMedia('(pointer: coarse)').matches;
  const uaMobiel = /Mobi|Android|iPhone|iPod/i.test(navigator.userAgent)
    // iPadOS doet zich voor als Macintosh maar heeft touch:
    || (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1);
  const touch = navigator.maxTouchPoints > 0 || 'ontouchstart' in window;
  return coarse && (uaMobiel || touch);
}

export function isWebAuthnSupported() {
  return window.PublicKeyCredential !== undefined;
}

// Regel 5: de detectie krijgt een grens. Zonder timeout hangt de vraag "kan dit
// toestel biometrie?" net zo lang als de trage kant -- en zolang stond hier een
// spinner in plaats van een login.
export async function platformBioBeschikbaar(timeoutMs = 2000) {
  if (!window.isSecureContext) return false;
  if (!window.PublicKeyCredential?.isUserVerifyingPlatformAuthenticatorAvailable) return false;
  try {
    return await Promise.race([
      window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable(),
      new Promise((resolve) => setTimeout(() => resolve(false), timeoutMs)),
    ]);
  } catch {
    return false;
  }
}

// Het loginscherm vraagt het omgekeerde: is er zeker GEEN platform-authenticator?
// Traag of een fout is geen nee -- dan blijft de bio-knop staan (Henk 19-10-2026).
export async function platformBioDefinitiefAfwezig() {
  if (!window.isSecureContext) return true;
  if (!window.PublicKeyCredential?.isUserVerifyingPlatformAuthenticatorAvailable) return true;
  try {
    return (await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable()) === false;
  } catch {
    return false;
  }
}
